<template>
  <v-container fluid fill-height style="background: #2078a0;">
    <v-layout align-center justify-center style="z-index: 3">
      <div class="login-container">
        <v-card v-if="currentView === 'login'">
          <v-toolbar color="white" card>
            <v-toolbar-title class="text-xs-center mx-auto">Войти в <span class="dms-logo">DMS</span></v-toolbar-title>
          </v-toolbar>
          
          <v-card-text>
            <v-alert
              v-model="showAlert"
              color="red"
              icon="warning"
              outline
              dismissible
            >
              {{ errorMessage }}
            </v-alert>
            <a @click="showEnterCode" v-if="needConfirm">Подтвердить</a>
            
            <v-form ref="form" v-model="valid" class="mt-4" lazy-validation onSubmit="return false;">
              <v-text-field
                class="custom"
                prepend-icon="person"
                v-model="username"
                label="Логин"
                name="login"
                :rules="[v => !!v || 'Необходимо ввести Логин']"
                required
                @keyup.13="login"
                :disabled="isLoading"
              />
              <v-text-field
                prepend-icon="lock"
                v-model="password"
                label="Пароль"
                name="password"
                :rules="[v => !!v || 'Необходимо ввести Пароль']"
                required
                @keyup.13="login"
                :type="viewMode ? 'text' : 'password'"
                :append-icon="viewMode ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="viewMode=!viewMode"
                :disabled="isLoading"
              />
            </v-form>
            
            <div class="pt-2">
              <a @click="resetPassword" v-show="!isLoading" class="light-blue--text text--darken-2">Забыли пароль?</a>
            </div>
          </v-card-text>
          
          <v-card-actions>
            <v-btn color="light-blue darken-2" dark flat @click.native="register" :disabled="isLoading">Регистрация</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="light-blue darken-2" dark @click="login" :disabled="isLoading" :loading="isLoading">Войти</v-btn>
          </v-card-actions>
        </v-card>
        
        <template v-else>
          <ConfirmCode
            :userName="username"
            :forceSend = needConfirm
            context="reg"
            v-on:cancel="cancelEnterCode"
            v-on:confirm="codeConfirmed"
          />
        </template>
      
      </div>
    </v-layout>
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <component v-if="dialog" :is="dialogView" @close-dialog="dialog=false"></component>
    </v-dialog>
    <ul class="bg-bubbles">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { isEmpty } from 'lodash'
  import apiAuth from "../api"
  import RegisterForm from './RegisterForm'
  import ResetForm from './ResetForm'
  import ConfirmCode from './ConfirmCode'
  
  export default {
    name: 'Login',
    
    components: {
      RegisterForm,
      ResetForm,
      ConfirmCode
    },
    
    data() {
      return {
        username: '',
        password: '',
        
        currentView: 'login',
        dialog: false,
        dialogView: null,
        needConfirm: false,
        isLoading: false,
        
        errorMessage: '',
        valid: true,
        viewMode: false,
      }
    },
    
    computed:{
      ...mapGetters('app/layout', ['getRouteData']),
      showAlert: {
        get: function() {
          return !isEmpty(this.errorMessage)
        },
        set: function(newValue) {
          if (!newValue) this.errorMessage = ''
        }
      }
    },
    
    methods: {
      register() {
        this.dialogView = RegisterForm
        this.dialog = true
      },
      
      resetPassword() {
        this.dialogView = ResetForm
        this.dialog = true
      },
      
      routeAccount: function() {
        return this.getRouteData({ name: 'account' })
      },
      
      login() {
        this.errorMessage = ''
        
        if (this.$refs.form.validate()) {
          this.isLoading = true
          
          if( this.username.indexOf("@") < 0 ){
            this.username = this.username.replace(/[^0-9]/gim,'')
          }
          
          apiAuth.signIn({'email_phone': this.username,  'password': this.password }).then(response => {
            if (response.status === 200) {
              // Success login - Save tokens to store and LocalStorage
              if (localStorage) {
                localStorage.setItem("dms_auth_tokens", JSON.stringify(response.data))
              }
              this.$store.commit('app/account/setAuthTokens', response.data)
              
              if (this.$route.query.continue) {
                this.$router.push(this.$route.query.continue)
              } else {
                document.location.assign(process.env.APP_ACCOUNT_URL+'?from=auth' || '/account?from=auth')
              }
            } else {
              this.errorMessage = "Unknown server response."
            }
            
          }).catch(error => {
            this.errorMessage = error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "Server connection error"
            if (error.response && error.response.data && error.response.data.code === 'account.user_not_confirm') {
              this.needConfirm = true
            }
          }).finally(() => {
            this.isLoading = false
          })
        }
      },
      
      codeConfirmed() {
        this.$store.dispatch('toaster/show', {
          text: 'Код успешно подтверждён',
        })
        
        document.location.assign(process.env.APP_ACCOUNT_URL || '/account')
      },
      
      showEnterCode() {
        this.errorMessage = ''
        this.currentView = 'code'
      },
      
      cancelEnterCode() {
        this.errorMessage = ''
        this.currentView = 'login'
      }
    }
  }
</script>

<style scoped>
  .error--text{
    color: #f44336 !important;
    caret-color: #f44336 !important;
  }
  
  .login-container{
    width: 600px;
    max-width: 100%;
  }
  .dms-logo{
    background: #1E6D96;
    color: white;
    padding: 5px 10px;
    font-family: "Times New Roman";
    font-size: 24px;
    font-weight: bold;
  }
  .bg-bubbles {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
  .bg-bubbles li {
    position: absolute;
    list-style: none;
    display: block;
    width: 40px;
    height: 40px;
    background-color: rgba(255, 255, 255, 0.15);
    bottom: -160px;
    -webkit-animation: square 100s infinite;
    animation: square 60s infinite;
    transition-timing-function: linear;
  }
  .bg-bubbles li:nth-child(1) {
    left: 10%;
  }
  .bg-bubbles li:nth-child(2) {
    left: 20%;
    width: 80px;
    height: 80px;
    -webkit-animation-delay: 2s;
    animation-delay: 2s;
    -webkit-animation-duration: 40s;
    animation-duration: 40s;
  }
  .bg-bubbles li:nth-child(3) {
    left: 25%;
    -webkit-animation-delay: 4s;
    animation-delay: 4s;
  }
  .bg-bubbles li:nth-child(4) {
    left: 40%;
    width: 60px;
    height: 60px;
    -webkit-animation-duration: 30s;
    animation-duration: 30s;
    background-color: rgba(255, 255, 255, 0.25);
  }
  .bg-bubbles li:nth-child(5) {
    left: 70%;
  }
  .bg-bubbles li:nth-child(6) {
    left: 80%;
    width: 120px;
    height: 120px;
    -webkit-animation-delay: 3s;
    animation-delay: 3s;
    background-color: rgba(255, 255, 255, 0.2);
  }
  .bg-bubbles li:nth-child(7) {
    left: 32%;
    width: 160px;
    height: 160px;
    -webkit-animation-delay: 7s;
    animation-delay: 7s;
  }
  .bg-bubbles li:nth-child(8) {
    left: 55%;
    width: 20px;
    height: 20px;
    -webkit-animation-delay: 15s;
    animation-delay: 15s;
    -webkit-animation-duration: 40s;
    animation-duration: 40s;
  }
  .bg-bubbles li:nth-child(9) {
    left: 25%;
    width: 10px;
    height: 10px;
    -webkit-animation-delay: 2s;
    animation-delay: 2s;
    -webkit-animation-duration: 30s;
    animation-duration: 30s;
    background-color: rgba(255, 255, 255, 0.3);
  }
  .bg-bubbles li:nth-child(10) {
    left: 90%;
    width: 160px;
    height: 160px;
    -webkit-animation-delay: 11s;
    animation-delay: 11s;
  }
  @-webkit-keyframes square {
    0% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
    }
    /*50% {
      -webkit-transform: translateY(-400px) rotate(600deg);
              transform: translateY(-400px) rotate(600deg);
    }*/
    100% {
      -webkit-transform: translateY(-1500px) rotate(600deg);
      transform: translateY(-1500px) rotate(600deg);
    }
  }
  @keyframes square {
    0% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
    }
    /*50% {
      -webkit-transform: translateY(-700px) rotate(600deg);
              transform: translateY(-700px) rotate(600deg);
    }*/
    100% {
      -webkit-transform: translateY(-1500px) rotate(600deg);
      transform: translateY(-1500px) rotate(600deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/auth/components/Login.vue